import { Injectable } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { Store } from '@ngrx/store'
import { LosDiscountBaseFilter } from '@tokeet-frontend/los-discount'
import { UserStorage } from '@tokeet-frontend/tv3-platform'
import { FilterGroup } from '@tv3/services/utils/filters.service'

@Injectable({ providedIn: 'root' })
export class LosDiscountFilter extends LosDiscountBaseFilter {
  constructor(protected store: Store<any>, protected fb: FormBuilder, protected storage: UserStorage) {
    super(store, fb, storage, FilterGroup.LosDiscounts)
  }
}
